export default __webpack_public_path__ + "../staticImages/icon-error-delay.gif";